
import { JasperService } from './../../../shared/jasper.service';
import { ControlStatusService } from './../../../shared/control-status.service';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormField } from '../formulario-relatorios';
import { FormularioRelatorioControlService } from './../formulario-relatorio-control.service';
import { Component, Input,   OnChanges } from '@angular/core';
import {  reportType, conjuntoRelatorios, Util } from '../../../../app/shared/Util';
import { DashboardService } from './../../../dashboard/dashboard.service';
import { AvaliacaoService } from './../../../modal-avaliacao/avaliacao.service';
import { NgFor, NgIf, JsonPipe } from '@angular/common';
import { InputRelatoriosComponent } from '../input-relatorios/input-relatorios.component';
import { ModalAvaliacaoComponent } from '../../../modal-avaliacao/modal-avaliacao.component';

declare let $: any
@Component({
    selector: 'app-formulario-relatorio',
    templateUrl: './formulario-relatorio.component.html',
    styleUrls: ['./formulario-relatorio.component.css'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgFor, InputRelatoriosComponent, NgIf, ModalAvaliacaoComponent, JsonPipe]
})
export class FormularioRelatorioComponent implements OnChanges {

  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;
  formularioDados = ' ';
  urlJasper: string;
  formatoRelatorio: reportType
  roteiroSelecionado: string;
  pastaSelecionado: string;
  exibirModalAvaliacao: boolean = false;
  constructor(private formfieldService: FormularioRelatorioControlService,
    private controlStatus: ControlStatusService,
    private jasperService: JasperService,
    public avaliacaoService: AvaliacaoService,
    private util: Util) { }

  ngOnChanges(): void {
    this.form = this.formfieldService.toFormGroup(this.formFields);
  }

  onSubmit() {
    this.formularioDados = JSON.parse(JSON.stringify(this.form.getRawValue()));
    Object.entries(this.formularioDados).forEach(([key, value]) => {
      switch (key) {
        case 'fileFormat':
          //PDF VALOR PADRAO
          this.formatoRelatorio = reportType.pdf
          this.controlStatus.controleModeloReport = 'pdf'

          //EXCEL 
          if ((value.toString().toUpperCase() == 'EXCEL' || value.toString().toUpperCase() == 'XLSX')) {
            this.formatoRelatorio = reportType.excel
            this.controlStatus.controleModeloReport = 'excel'
          }

          break;
        case 'dtInicio':
          this.controlStatus.dataInicio = value;
          break;
        case 'dtFinal':
          this.controlStatus.dataFim = value;
          break;
        case 'empresa':
          this.controlStatus.empresaSelecionada = value;
          break;
        case 'roteiro':
          this.roteiroSelecionado = value;
          break;
        case 'motorista':
          this.controlStatus.nomeMotorista = value;
          break;          
      }
    })

      this.openJasperReport();
  }

  async openJasperReport() {
    this.controlStatus.avisoRelatorio = 'Carregando Informações...'

    switch(this.controlStatus.controleModeloReport.toUpperCase()){
      case 'PDF':
        this.controlStatus.carregandoRelatoriosJasper = true;
        $("#modalJasper").modal('show');
        this.urlJasper = await this.jasperService.carregaUrlJasper(this.controlStatus.reportName, this.formatoRelatorio, this.roteiroSelecionado);
        window.open(this.urlJasper, 'myFrame');
        break;
      case 'EXCEL':
        this.controlStatus.carregandoRelatorios = true
        this.urlJasper = await this.jasperService.carregaUrlJasper(this.controlStatus.reportName2, this.formatoRelatorio, this.roteiroSelecionado);  
        const downloadWindow = window.open(this.urlJasper, 'DownloadWindow');
        const checkDownload = setInterval(() => {
          if (downloadWindow.closed) {
            clearInterval(checkDownload);
            setTimeout (()=> this.controlStatus.carregandoRelatorios= false, 2000);         
          }
        }, 500);
        break;
        default: //same pdf 
          this.controlStatus.carregandoRelatoriosJasper = true;
          $("#modalJasper").modal('show');
          this.urlJasper = await this.jasperService.carregaUrlJasper(this.controlStatus.reportName, this.formatoRelatorio, this.roteiroSelecionado);
          window.open(this.urlJasper, 'myFrame');
          break;
    }
    this.verificaExisteAvaliacao()
  }

  fechaModal() {
    $('#modalRelJasper').modal('hide')
    this.controlStatus.limpaEstadoRelatorios()
  }

  async verificaExisteAvaliacao() {
    try {
      const response = await this.avaliacaoService.getAvaliacaoPesquisa('RELATORIO');

      this.avaliacaoService.exibirModalAvaliacao = Array.isArray(response) && response.length > 0;

    } catch (error) {
      console.error('Erro ao verificar avaliação:', error);
    }
  }

  fecharModalAvaliacao() {
    this.avaliacaoService.exibirModalAvaliacao = false;
  }
}
